import React from "react";
import { atom, useRecoilState } from "recoil";

export const getUserEntity = atom({
  key: "getUserEntity",
  default: "Users",
});

const UserEntityToggle = () => {
  const [userEntity, setUserEntity] = useRecoilState<any>(getUserEntity);

  const handleAppNameClick = (name: string | null) => {
    setUserEntity(name);
  };

  const buttonStyle = {
    cursor: "pointer",
    padding: "12px 24px",
    transition: "color 0.3s, transform 0.3s, box-shadow 0.3s",
    marginLeft: "20px",
    color: "#333",
    fontFamily: "Arial, sans-serif",
    fontSize: "16px",
    border: "none",
    backgroundColor: "transparent",
    position: "relative",
    overflow: "hidden",
    zIndex: 1,
    boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
  };

  const activeButtonStyle: any = {
    ...buttonStyle,
    color: "#009cde",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
  };

  const activeUnderlineStyleUsers: any = {
    position: "absolute",
    left: 0,
    bottom: 0,
    width: "100%",
    height: "2px",
    backgroundColor: "#009cde",
    transform: userEntity === "Users" ? "scaleX(1)" : "scaleX(0)",
    transformOrigin: "left",
    transition: "transform 0.3s",
    zIndex: -1,
  };
  const activeUnderlineStyleEntities: any = {
    position: "absolute",
    left: 0,
    bottom: 0,
    width: "100%",
    height: "2px",
    backgroundColor: "#009cde",
    transform: userEntity === "Entities" ? "scaleX(1)" : "scaleX(0)",
    transformOrigin: "left",
    transition: "transform 0.3s",
    zIndex: -1,
  };


  return (
    <div>
      <button
        onClick={() => {
          handleAppNameClick("Users");
        }}
        style={userEntity === "Users" ? activeButtonStyle : buttonStyle}
      >
        Users
        <div style={activeUnderlineStyleUsers}></div>
      </button>
      {/* Future reference */}
      {/* <button
        onClick={() => {
          handleAppNameClick("Entities");
        }}
        style={userEntity === "Entities" ? activeButtonStyle : buttonStyle}
        disabled = {true}
      >
        Entities
        <div style={activeUnderlineStyleEntities}></div>
      </button> */}
    </div>
  );
};

export default UserEntityToggle;
